import { addMinutes, format } from 'date-fns';
import moment from 'moment';
import { paymentTypeDictionary } from '../constants/Payment';

export const formatCurrency = (value: number) => {
  if (isNaN(value)) return '';

  const isNegative = value < 0;
  const absNumber = Math.abs(value);

  if (isNegative) {
    let formattedNumber = new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2,
    }).format(absNumber);
    formattedNumber = `- ${formattedNumber}`;
    return formattedNumber;
  } else {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2,
    }).format(value);
  }
};

export const validateRegexEmail = (value: string) => {
  const regexEmail = new RegExp(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/);
  return regexEmail.test(value);
};

export const validatePassword = (value: string) => {
  const minLengthPassword: number = 5;
  return value.length > minLengthPassword;
};

export const validateCardTagId = (value: string) => {
  const minLengthPassword: number = 7;
  return value.length > minLengthPassword;
};

export const validateCompletName = (name: string) => {
  const nomeSobrenomeRegex = new RegExp(
    /\b[A-Za-zÀ-ú][A-Za-zÀ-ú]+,?\s[A-Za-zÀ-ú][A-Za-zÀ-ú]{2,19}\b/gi
  );
  return nomeSobrenomeRegex.test(name);
};

export const validateCellNumber = (cell: string) => {
  const phoneRegex = RegExp(/^((\([0-9]{2}\))\s([0-9]{4,5})-([0-9]{4}))?$/gm);
  return phoneRegex.test(cell);
};

export const validateBirthdayDate = (cell: string) => {
  const ddmmRegex = RegExp(
    /^((3[01]|[12][0-9]|0[1-9])\/(1[0-2]|0[1-9])\/[0-9]{4})?$/gm
  );
  return ddmmRegex.test(cell);
};

export const validateCPF = (cpf: string) => {
  const cpfRegex = RegExp(/\d{3}\.\d{3}\.\d{3}\-\d{2}/g);
  return cpfRegex.test(cpf);
};

export const formatKw = (value: number) => {
  if (isNaN(value)) return '';

  let formattedNumber = new Intl.NumberFormat('pt-BR', {
    style: 'decimal',
    maximumFractionDigits: 1,
    minimumFractionDigits: 1,
  }).format(value);
  //let returnVal = value?.toFixed(1).toString();
  return formattedNumber.toString();
};

export const formatKm = (value: number) => {
  if (isNaN(value)) return '';

  let formattedNumber = new Intl.NumberFormat('pt-BR', {
    style: 'decimal',
    maximumFractionDigits: 1,
    minimumFractionDigits: 1,
  }).format(value);
  //let returnVal = value?.toFixed(1).toString();
  return formattedNumber.toString();
};

export const formatPercent = (value: number) => {
  let returnVal = value?.toFixed(1).toString();
  return `${returnVal} %`;
};

export const formatTimeWithoutDays = (value: string) => {
  return value?.substring(3);
};

export const getFormatedTimeMiliSeconds = (miliSecondsTime: number) => {
  let total_seconds = Math.floor(miliSecondsTime / 1000);
  let total_minutes = Math.floor(total_seconds / 60);
  let total_hours = Math.floor(total_minutes / 60);
  let total_days = Math.floor(total_hours / 24);

  let seconds = total_seconds % 60;
  let minutes = total_minutes % 60;
  let hours = total_hours % 60;
  let days = total_days % 24;

  return `${hours.toString().padStart(2, '0')}:${minutes
    .toString()
    .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
};

export const getTotalSeconds = (time: string) => {
  const parts = time?.split(':');
  const days = parseInt(parts[0], 10);
  const hours = parseInt(parts[1], 10);
  const minutes = parseInt(parts[2], 10);
  const seconds = parseInt(parts[3], 10);
  return days * 86400 + hours * 3600 + minutes * 60 + seconds;
};

export const getTotalMiliSeconds = (time: string) => {
  const parts = time?.split(':');
  const days = parseInt(parts[0], 10);
  const hours = parseInt(parts[1], 10);
  const minutes = parseInt(parts[2], 10);
  const seconds = parseInt(parts[3], 10);
  return days * 86400 + hours * 3600 + minutes * 60 + seconds;
};

export const formatTime = (totalSeconds: number) => {
  let days = Math.floor(totalSeconds / 86400);
  let hours = Math.floor((totalSeconds - days * 86400) / 3600);
  let minutes = Math.floor((totalSeconds - days * 86400 - hours * 3600) / 60);
  let seconds = totalSeconds % 60;
  return `${hours.toString().padStart(2, '0')}:${minutes
    .toString()
    .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
};

export const formatCmcType = (cmcType: string) => {
  return cmcType?.replace(/,/g, ' e ');
};

export const getOperationHours = (operationHours: string) => {
  if (operationHours) {
    let operationHoursParse = JSON.parse(operationHours);
    const diaAtual = new Date().getDay();
    if (
      diaAtual >= 0 &&
      diaAtual < operationHoursParse.length &&
      operationHoursParse[diaAtual].isOpen
    ) {
      const horarioAtual = operationHoursParse[diaAtual];
      return `${horarioAtual?.from} às ${horarioAtual.to}`;
    } else if (
      diaAtual >= 0 &&
      diaAtual < operationHoursParse.length &&
      !operationHoursParse[diaAtual].isOpen
    ) {
      return '';
    } else {
      return 'Não há informação de disponibilidade para hoje.';
    }
  }
};

export const getTypeCard = (item_type: any) => {
  const valorCorrespondente = paymentTypeDictionary[item_type];
  if (valorCorrespondente !== undefined) {
    return valorCorrespondente;
  }
  console.error('Valor correspondente não encontrado no dicionário.');
  return undefined;
};

export const calculateTime = (startTime: Date, endTime: Date): string => {
  const minutes = (endTime.getTime() - startTime.getTime()) / (1000 * 60);

  if (minutes < 1) {
    return `${Math.round(minutes * 60)
      .toString()
      .padStart(2, '0')} seg`;
  }

  if (minutes < 60) {
    return `${Math.round(minutes).toString().padStart(2, '0')} min`;
  }

  const hours = Math.floor(minutes / 60);
  const remainingMinutes = Math.round(minutes % 60);

  return `${hours.toString().padStart(2, '0')}h ${remainingMinutes
    .toString()
    .padStart(2, '0')}min`;

  // return (
  //   Math.round(minutes / 60)
  //     .toString()
  //     .padStart(2, "0") +
  //   "h" +
  //   Math.round(minutes % 60)
  //     .toString()
  //     .padStart(2, "0") +
  //   "min"
  // );
};

export const formatDateWalletHistoryFounds = (rawDate: string) => {
  const date = new Date(rawDate);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = String(date.getFullYear());

  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');

  // BR datetime
  const hoursBRComplete = `${hours}:${minutes}h`;
  const dateFormatBR = `${day}/${month}`;
  const datetimeBR = `${dateFormatBR} - ${hoursBRComplete}`;

  return datetimeBR;
};
export const formatDateWalletHistoryCharger = (
  rawStartDate: string,
  rawStopDate: string
): string => {
  // Start date
  const startDate = new Date(rawStartDate);
  const getStartDay = String(startDate.getDate()).padStart(2, '0');
  const getStartMonth = String(startDate.getMonth() + 1).padStart(2, '0');
  const getStartHours = String(startDate.getHours()).padStart(2, '0');
  const getStartMinutes = String(startDate.getMinutes()).padStart(2, '0');

  // Stop date
  const stopDate = new Date(rawStopDate);
  const getStopDay = String(stopDate.getDate()).padStart(2, '0');
  const getStopMonth = String(stopDate.getMonth() + 1).padStart(2, '0');
  const getStopHours = String(stopDate.getHours()).padStart(2, '0');
  const getStopMinutes = String(stopDate.getMinutes()).padStart(2, '0');

  const usageLoad = calculateTime(startDate, stopDate);

  // BRL date format
  let newStartBR = `${getStartDay}/${getStartMonth} • ${getStartHours}:${getStartMinutes}h`;
  let newStopBR = `${getStopDay}/${getStopMonth} • ${getStopHours}:${getStopMinutes}h`;
  let dateFormatBR = `${newStartBR} - ${newStopBR} (${usageLoad})`;
  if (`${getStartDay}/${getStartMonth}` === `${getStopDay}/${getStopMonth}`) {
    newStartBR = `${getStartDay}/${getStartMonth} • ${getStartHours}:${getStartMinutes}h`;
    newStopBR = `${getStopHours}:${getStopMinutes}h`;
    dateFormatBR = `${newStartBR} - ${newStopBR} (${usageLoad})`;
  }

  return dateFormatBR;
};

export function formatDateWalletHistory(value: Date, language?: string) {
  return format(value, "dd/MM/yyyy '•' HH:mm'h'");
}

export const formatSpottCashChargedDetail = (
  rawStartDate: string,
  rawStopDate: string
): string => {
  // Start date
  const startDate = new Date(rawStartDate);
  const getStartYear = String(startDate.getFullYear());
  const getStartDay = String(startDate.getDate()).padStart(2, '0');
  const getStartMonth = String(startDate.getMonth() + 1).padStart(2, '0');
  const getStartHours = String(startDate.getHours()).padStart(2, '0');
  const getStartMinutes = String(startDate.getMinutes()).padStart(2, '0');

  // Stop date
  const stopDate = new Date(rawStopDate);
  const getStopYear = String(startDate.getFullYear());
  const getStopDay = String(stopDate.getDate()).padStart(2, '0');
  const getStopMonth = String(stopDate.getMonth() + 1).padStart(2, '0');
  const getStopHours = String(stopDate.getHours()).padStart(2, '0');
  const getStopMinutes = String(stopDate.getMinutes()).padStart(2, '0');

  const usageLoad = calculateTime(startDate, stopDate);

  // BRL date format
  let newStartBR = `${getStartDay}/${getStartMonth}/${getStartYear} • ${getStartHours}:${getStartMinutes}h`;
  let newStopBR = `${getStopDay}/${getStopMonth}/${getStopYear} • ${getStopHours}:${getStopMinutes}h`;
  let dateFormatBR = `${newStartBR} - ${newStopBR} (${usageLoad})`;
  if (
    `${getStartDay}/${getStartMonth}/${getStartYear}` ===
    `${getStopDay}/${getStopMonth}/${getStopYear}`
  ) {
    newStartBR = `${getStartDay}/${getStartMonth}/${getStartYear} • ${getStartHours}:${getStartMinutes}h`;
    newStopBR = `${getStopHours}:${getStopMinutes}h`;
    dateFormatBR = `${newStartBR} - ${newStopBR} (${usageLoad})`;
  }

  return dateFormatBR;
};

export function convertBirthDate(birthdayDate: string): string {
  //const [day, month, year] = birthdayDate.split('/');

  const newDate = moment(birthdayDate, 'DD/MM/YYYY').toDate();
  //console.log(newDate.toString());
  // const newYear = newDate.getFullYear();
  // const newMonth = (newDate.getMonth()+1).toString().padStart(2, '0');
  // const newDay = newDate.getDate().toString().padStart(2, '0');

  // const returnData = `${newYear}-${newMonth}-${newDay}`;
  // console.log('newDate ' + newDate.toISOString().substring(0,10));
  // console.log('convertBirthDate ' + returnData);
  return newDate.toISOString().substring(0, 10);
}

export const formatHoursMinutes = (period: number) => {
  const baseDate = new Date(1970, 0, 1, 0, 0, 0);
  const newDate = addMinutes(baseDate, period);
  const hours = format(newDate, 'H');
  const minutes = format(newDate, 'm');
  return `${hours}h${minutes}min`;
};
